import { createStore } from 'vuex'

export default createStore({
    state: {
        dominio:'https://sistemacarnet.sansalvadorsur.gob.sv/api',
        user:null,
        token:null,
        rol:null
    },
    getters: {
        getUser(state){
            return state.user;
        },
        getToken(state){
            return state.token;
        },
        getRol(state){
            return state.rol;
        }
    },
    mutations: {
        setUser(state,data){
            state.user = data;
        },
        setToken(state,data){
            state.token = data;
        },
        setRol(state,data){
            state.rol = data;
        },
    },
    actions: {
        login(context,data){
            context.commit('setUser',data.user);
            context.commit('setToken',data.token);
            context.commit('setRol',data.rol);
      
            localStorage.setItem('userData',JSON.stringify(data))
      
          },
          logout(context){
            context.commit('setUser',null);
            context.commit('setToken',null);
            context.commit('setRol',null);
      
            localStorage.removeItem('userData');
          }
    },
    modules: {
    }
})
